import { Box, Divider, Typography } from "@mui/material";
import { useState } from "react";
import SearchInput from "../../components/filters/SearchInput";

/**
 * Demo component for SearchInput
 * Shows how to implement search functionality
 */
const SearchInputDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({
    searchString: "",
  });

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="subtitle2">Basic Search Implementation:</Typography>
      <Box maxWidth={400}>
        <SearchInput
          fieldName="searchString"
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
        />
      </Box>

      <Divider />

      <Typography variant="subtitle2">Current Search Value:</Typography>
      <Typography variant="body2" fontStyle="italic">
        {appliedFilters.searchString
          ? `Searching for: "${appliedFilters.searchString}"`
          : "No search query entered"}
      </Typography>
    </Box>
  );
};

export default SearchInputDemo;
